export class UserModel {
    ID: number;
    UserName: string;
    ParentUserName: string;
    Bonus: number;
    UserType: string;
    UserTypeName: string;
    UserLeve: string;
    UserLeveName: string;
    UserMoney: number;
    UserLockMoney: number;
    UserIntegral: number;
    State: string;

    LoginIP: string;
    LoginGuid: string;
    TryLogCnt: number;

    RegistTime: string;

    CanDailyWages: boolean;
    HasDailyWages: boolean;
    GASecret: string;
    HasDividend: boolean;

}

export class AppInfo {
    constructor() {
        this.AndroidContent = "",
            this.AndroidDate = "20180606",
            this.AndroidUrl = "",
            this.AndroidVersion = "1.0.0",
            this.IosContent = "",
            this.IosDate = "20180606",
            this.IosUrl = "",
            this.IosVersion = "1.0.0",
            this.IsOpen = false
    }
    AndroidContent: string;
    AndroidDate: string;
    AndroidUrl: string;
    AndroidVersion: string;
    IosContent: string;
    IosDate: string;
    IosUrl: string;
    IosVersion: string;
    IsOpen: boolean;
}

export class SysconfigModel {
    ID: number;
    MinBonus: number;
    MaxBonus: number;
    LimitUserName: string;
    RewardUp: number;
    RewardDown: number;
    PerGraduation: number;
    BonusGruduation: number;
    BasicReward: number;
    AdjustMaxBonus: number;
    AdjustMinBonus: number;
    PerBettingPrice: number;
    PerMaxReward: number;
    MaxMultiple: number;
    MinMultiple: number;
    CanDecimal: boolean;
    DefaultMultiple: number;
    LatestRevotion: number;
    MaxWithDraw: number;
    MinWithDraw: number;
    WithDrawTimes: number;
    StartWithDrawTime: Date;
    EndWithDrawTime: Date;
    StartWithDrawTime1: Date;
    EndWithDrawTime1: Date;
    ClientMaxBonus: number;
    ClientMinBonus: number;
    ClientGraduation: number;
    DefaultLess: number;
    DefaultOutLineOfTime: number;
    DefaultOnlineNumber: number;
    OnlineNumberMultiple: number;
    QueuePerson: number;
    DrawCashCommt: string;
    AutoLotteryProportion: number;
    IsAutoLotteryOpen: boolean;
    LateOpenMiinute: number;
    IsTotalCanBetting: boolean;
    MaxUserBonusCanBetting: number;
    MaxChaseIssue: number;
    IsOpenOnlineNumber: boolean;
    HotBattleDisplay: string;
    ProxySendMsg: string;
    ClientVersion: string;
    CustomerServiceUrl: string;
    IsQueueService: boolean;
    QueueNum: number;
    CustomerServiceMode: string;
    CanAdjust: boolean;
    FixedRewardMode: number;
    OpenTotal: boolean;
    TotalNum: number;
    IsOpenMachine: boolean;
    RecentOpenNum: number;
    IsYuanJiaoFen: boolean;
    JiaoMaxMode: number;
    FenMaxMode: number;
    AdjustShowMaxMode: boolean;
    BettingIssueAlert: boolean;
    IssueAlertTime: number;
    OpenIssueAlertTime: boolean;
    TestUserStaticLotteryRank: boolean;
    AutoLotteryKoProprotion: number;
    TransferReward: number;
    NewUserLinkBonus: number;
    WithdrawMinPercent: number;
    DaySalaryMode: string;
    CdnPath: string;
    Debug: boolean;
    IssueMaxProfit: number;
    KqIssueMaxProfit: number;
}




// WEBPACK FOOTER //
// ./src/models/user.model.ts